/**
 * Client-side reading-time estimate for article jackets. Mirrors
 * ArticleBody#calculate_reading_time — 200 wpm, the house constant — because
 * the server's value never reaches the wire today.
 *
 * UPSTREAM PROPOSAL (jacket-feed written notes): ship `reading_time` on
 * PlayableItem and delete this.
 */
export function estimateReadingMinutes(body: string): number {
  const words = body
    .replace(/<[^>]*>/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length
  return Math.max(1, Math.ceil(words / 200))
}
